/* eslint-disable */
//import langEN from '@/scripts/lang/lang-en.js';
//import langTW from '@/scripts/lang/lang-tw.js';
import langIStoreEN from '@/scripts/lang/lang-istore-en.js';
import langIStoreJA from '@/scripts/lang/lang-istore-ja.js';
import langIStoreCN from '@/scripts/lang/lang-istore-cn.js';
import langIStoreTW from '@/scripts/lang/lang-istore-tw.js';
import languagesInit from '@/assets/init/languages.json';
import iStoreApi from '@/scripts/istore-api.js';
import $store from '@/store/index.js'
import { reactive } from 'vue';

const LANGUAGE_KEY_PREFIX = 'language.'
const LEGACY_LANGUAGE_KEY_PREFIX = 'language.system.language.'

const normalizeLanguageStorageKey = (key) => {
  if (!key) return ''
  if (key.startsWith(LEGACY_LANGUAGE_KEY_PREFIX)) {
    return LANGUAGE_KEY_PREFIX + key.slice(LEGACY_LANGUAGE_KEY_PREFIX.length)
  }
  if (key.startsWith(LANGUAGE_KEY_PREFIX)) {
    return key
  }
  return LANGUAGE_KEY_PREFIX + key
}

const langDefinition = {
  en: { font: 'font-default', key: 'en', value: 'English', localeCode: 'US', langCode: 'enUS', local: null },
  ja: { font: 'font-ja', key: 'ja', value: '日本語', localeCode: 'JP', langCode: 'jaJP', local: null },
  cn: { font: 'font-cn', key: 'cn', value: '簡体', localeCode: 'CN', langCode: 'zhCN', local: null },
  tw: { font: 'font-tw', key: 'tw', value: '繁體', localeCode: 'TW', langCode: 'zhTW', local: null },
};

export let defaultKey = (window.navigator.userLanguage || window.navigator.language).toLowerCase();
if (defaultKey === 'zh-tw') {
  defaultKey = 'tw';
} else if (defaultKey === 'zh-cn') {
  defaultKey = 'cn';
} else if (defaultKey === 'ja') {
  defaultKey = 'ja';
} else {
  defaultKey = 'en';
}
//export const currentLangKey = Object.assign({}, langIStoreTW);

export const langControl = reactive({
  initType: langDefinition[defaultKey].key,
  initName: langDefinition[defaultKey].value,
  localeCode: langDefinition[defaultKey].localeCode,
  langCode: langDefinition[defaultKey].langCode,
  local: langDefinition[defaultKey].local,
  currentLangKey: Object.assign({}, langIStoreTW),
  types: [
    {
      name: langDefinition.en.value,
      value: langDefinition.en.key,
    },
    {
      name: langDefinition.ja.value,
      value: langDefinition.ja.key,
    },
    {
      name: langDefinition.cn.value,
      value: langDefinition.cn.key,
    },
    {
      name: langDefinition.tw.value,
      value: langDefinition.tw.key,
    },
  ],
  data: {
    en: langIStoreEN,
    tw: langIStoreTW,
    cn: langIStoreCN,
    ja: langIStoreJA,
  },
  get: function(_type, _key, _default) {
    const data = this.data[_type];
    let result = data[_key];
    if (result === undefined && _default !== undefined) {
      return _default;
    }
    if (result === undefined) {
      return null;
    }
    return result;
  },
  getLangData(key) {
    return {
      'langKey': key,
      'en': this.get('en', key),
      'tw': this.get('tw', key),
      'cn': this.get('cn', key),
      'ja': this.get('ja', key),
    }
  },
  change: function(_type) {
    if (_type && langDefinition[_type]) {
      this.initType = _type;
      this.initName = langDefinition[_type].value;
      this.localeCode = langDefinition[_type].localeCode;
      this.langCode = langDefinition[_type].langCode;
      this.local = langDefinition[_type].local;

      for (let _key of Object.keys(this.data[this.initType])) {
        this.currentLangKey[_key] = this.data[this.initType][_key];
      }

      this.currentLangKey._updateTime = Date.now()
      localStorage.setItem('lang', this.initType);
    }
  },
  getType() {
    return langControl.initType;
  },
  async syncDatabase(languages) {
    if (languages && languages.length > 0) {
      const langTypes = Object.keys(langDefinition)
      let langData = []
      for (let lang of languages) {
        const value = langControl.getLangData(lang.key)
        value[this.initType] = lang.value
        for (let tmp of langTypes) {
          // 沒有值的語系，套用現有的
          value[tmp] = lang.value ?? lang.key
        }
        langData.push({
          key: `${LANGUAGE_KEY_PREFIX}${lang.key}`,
          value: JSON.stringify(value),
        })
      }

      try {
        await iStoreApi.putBatch('language', langData)
      } catch (error) {
        console.error(error)
      }
    }
  },
  async init(app) {
    this.app = app
    // 會直接將上次使用的語言裝載至 langKey
    let _lang = localStorage.getItem('lang') ?? defaultKey;
    langControl.change(_lang);

    const r = await iStoreApi.getDatabase('language');

    if (r.data && r.data.length > 0) {
      const existingKeys = new Set(r.data.map(d => d.value.langKey));
      for (let d of r.data) {
        let { langKey, en, tw, cn, ja } = d.value;
        langControl.data['en'][langKey] = en
        langControl.data['tw'][langKey] = tw
        langControl.data['cn'][langKey] = cn
        langControl.data['ja'][langKey] = ja
      }

      const applyDefaultLang = (key, defaults) => {
        const types = ['en', 'tw', 'cn', 'ja']
        for (let t of types) {
          const current = langControl.data[t][key]
          if (!current || current === key) {
            const fallback = defaults[t]
            if (fallback) {
              langControl.data[t][key] = fallback
            }
          }
        }
      }

      for (let key of Object.keys(langIStoreEN)) {
        applyDefaultLang(key, {
          en: langIStoreEN[key],
          tw: langIStoreTW[key],
          cn: langIStoreCN[key],
          ja: langIStoreJA[key],
        })
      }

      const initLangEntries = Array.isArray(languagesInit) ? languagesInit : []
      let initLangData = []
      for (let entry of initLangEntries) {
        const value = entry.value || {}
        const key = value.langKey
        if (!key || existingKeys.has(key)) continue
        langControl.data['en'][key] = value.en ?? key
        langControl.data['tw'][key] = value.tw ?? key
        langControl.data['cn'][key] = value.cn ?? key
        langControl.data['ja'][key] = value.ja ?? key
        const storageKey = normalizeLanguageStorageKey(entry.key || `${LANGUAGE_KEY_PREFIX}${key}`)
        initLangData.push({
          key: storageKey,
          value: JSON.stringify(value),
        })
        existingKeys.add(key)
      }

      for (let entry of initLangEntries) {
        const value = entry.value || {}
        const key = value.langKey
        if (!key) continue
        applyDefaultLang(key, {
          en: value.en,
          tw: value.tw,
          cn: value.cn,
          ja: value.ja,
        })
      }

      langControl.change(langControl.initType);

      // 🟦 Prepare new language keys that are NOT in the database
      let langData = [];
      const allKeys = Object.keys(langIStoreEN); // assume EN has all base keys

      for (let key of allKeys) {
        if (!existingKeys.has(key)) {
          const value = {
            langKey: key,
            en: langIStoreEN[key],
            tw: langIStoreTW[key] ?? key,
            cn: langIStoreCN[key] ?? key,
            ja: langIStoreJA[key] ?? key,
          };

        langData.push({
          key: `${LANGUAGE_KEY_PREFIX}${key}`,
          value: JSON.stringify(value),
        });
        }
      }

      if (initLangData.length > 0) {
        langData = langData.concat(initLangData)
      }

      if (langData.length > 0) {
        try {
          await iStoreApi.putBatch('language', langData);
          console.info(`[langControl] Synced ${langData.length} new language keys to database.`);
        } catch (error) {
          console.error('[langControl] Failed to sync default languages:', error);
        }
      } else {
        console.info('[langControl] All language keys already exist. No sync needed.');
      }

    } else {
      // 🔵 Case 2: No language data at all — insert everything
      console.info('[langControl] No language data found. Syncing all defaults...');
      let langData = [];
      const allKeys = Object.keys(langIStoreEN);
      const insertedKeys = new Set()

      for (let key of allKeys) {
        const value = {
          langKey: key,
          en: langIStoreEN[key],
          tw: langIStoreTW[key] ?? key,
          cn: langIStoreCN[key] ?? key,
          ja: langIStoreJA[key] ?? key,
        };

        langData.push({
          key: `${LANGUAGE_KEY_PREFIX}${key}`,
          value: JSON.stringify(value),
        });
        insertedKeys.add(key)
      }

      const initLangEntries = Array.isArray(languagesInit) ? languagesInit : []
      for (let entry of initLangEntries) {
        const value = entry.value || {}
        const key = value.langKey
        if (!key || insertedKeys.has(key)) continue
        langControl.data['en'][key] = value.en ?? key
        langControl.data['tw'][key] = value.tw ?? key
        langControl.data['cn'][key] = value.cn ?? key
        langControl.data['ja'][key] = value.ja ?? key
        const storageKey = normalizeLanguageStorageKey(entry.key || `${LANGUAGE_KEY_PREFIX}${key}`)
        langData.push({
          key: storageKey,
          value: JSON.stringify(value),
        })
        insertedKeys.add(key)
      }

      try {
        await iStoreApi.putBatch('language', langData);
        console.info('[langControl] Default languages synced to empty database.');
      } catch (error) {
        console.error('[langControl] Failed to sync default languages:', error);
      }

      langControl.change(langControl.initType);
    }
  },
  updateLang(key, value) {
    if (typeof value === 'string') {
      this.currentLangKey[key] = value
    } else if (value[this.initType]) {
      this.currentLangKey[key] = value[this.initType]
    }
    this.currentLangKey._updateTime = Date.now()

    // Update function menu tree language update
    // Update Menu Folder
    $store.commit('updateFolderFunctionDisplayName', key)
  },
  updateFunctionDisplayName(userFunctions, key) {
    if (userFunctions) {
      // change all function and column display name from language
      for (const func of userFunctions) {
        const funcKey = `${func.module}.${func.name}`
        if (key === undefined || key === funcKey) {
          func.displayName = this.currentLangKey[funcKey] ?? func.name
          console.debug('updateFunctionDisplayName: ', func.displayName)
        }
        if (func.columns) {
          for (let column of func.columns) {
            const columnKey = `${func.module}.${func.name}.column.${column.name}`
            if (key === undefined || key === columnKey) {
              column.displayName = this.currentLangKey[columnKey] ?? column.name
            }
          }
        }

        // For Yeastar-style interface
        if (func.group !== undefined) {
          for (let tab of func.group.page.tabs) {
            if (tab.name !== null) {
              const tabKey = `${func.group.name}.${func.group.page.name}.tab.${tab.name}`
              tab.displayName = this.currentLangKey[tabKey] ?? tab.name
            }
            for (let section of tab.sections) {
              if (section.name !== null) {
                const sectionKey = `${func.group.name}.${func.group.page.name}.${tab.name}.section.${section.name}`
                section.displayName = this.currentLangKey[sectionKey] ?? section.name
              }
              for (let field of section.fields) {
                const fieldKey = `${func.group.name}.${func.group.page.name}.${tab.name}.${section.name}.field.${field.name}`
                field.displayName = this.currentLangKey[fieldKey] ?? field.name
                // To translate the column header (if useTableDisplay is set to true)
                if (func.group.page.table.columns !== undefined) {
                  const findObj = func.group.page.table.columns.find((f) => f.name === field.name)
                  if (findObj) {
                    findObj.displayName = this.currentLangKey[fieldKey] ?? field.name
                  }
                }
                // To translate the drop down options
                if (field.options !== undefined) {
                  for (let option of field.options) {
                    const fieldOptionKey = `${func.group.name}.${func.group.page.name}.${tab.name}.${section.name}.${field.name}.option.${option.name}`
                    option.displayName = this.currentLangKey[fieldOptionKey] ?? option.name
                  }
                }
                // To translate field placeholder
                if (field.placeholder !== "" && field.placeholder !== null) {
                  const fieldPlaceholderKey = `${func.group.name}.${func.group.page.name}.${tab.name}.${section.name}.field.placeholder.${field.name}`
                  field.placeholder = this.currentLangKey[fieldPlaceholderKey] ?? field.placeholder
                }
              }
            }
          }
        }
      }
    }
  },
  updateFolderDisplayName(menuFunctions, key) {
    for (const menu of menuFunctions) {
      const menuKey = `folder.level${menu.folderLevel}.${menu.folderName}`
      if (menu.folderName && key === menuKey) {
        menu.folderDisplayName = this.currentLangKey[menuKey] ?? menu.folderDisplayName
      }
      if (menu.folders) {
        this.updateFolderDisplayName(menu.folders, key)
      }
      if (menu.functions) {
        this.updateFunctionDisplayName(menu.functions, key)
      }
    }
  },
});

export default {
  install(app) {
    app.config.globalProperties.langKey = langControl.currentLangKey
  },
}
